import {
  DECRYPT_EMAIL_SUCCESS,
  DECRYPT_EMAIL_ERROR,
} from '../actions/constants'

const initialState = {
  decrpytedEmail: '',
  decrpytedEmailError: false,
}


export default (state = initialState, action) => {
  switch (action.type) {
    case DECRYPT_EMAIL_SUCCESS:
      return {
        ...state,
        decryptedEmail: action.response.output,
      }
    case DECRYPT_EMAIL_ERROR:
      return {
        ...state,
        decryptedEmailError: true,
      }
    default:
      return { ...state }
  }
}
